<template>
  <div class="home">
    <b-container>
      <b-row> </b-row>
    </b-container>

    <div class="slogan">
      <div class="banner text-center">
        <b-container>
          <b-row>
            <b-col cols="12" md="6">
              <div class="banner__content">
                <h2 class="banner__title">Trải nghiệm kỳ thi thực tế</h2>
                <h4 class="banner__sub-title">Nâng cao sự tự tin và kỹ năng làm bài thi HSK</h4>
              </div>
            </b-col>
          </b-row>
        </b-container>  
      </div>
      <b-container>
        <div class="statistic">
          <b-row align-h="center">
            <b-col cols="12" sm="4">
              <div class="statistic__item clearfix">
                <div class="statistic__item__icon">
                  <img src="@/assets/images/pages/home/connections.svg" width="96" alt="300.000+ Người thi">
                </div>
                <div class="statistic__item__content">
                  <span>300.000+ Người thi</span>
                </div>
              </div>
            </b-col>
            <b-col cols="12" sm="4">
              <div class="statistic__item clearfix">
                <div class="statistic__item__icon">
                  <img src="@/assets/images/pages/home/exam.svg" width="96" alt="1.000+ Đề thi">
                </div>
                <div class="statistic__item__content">
                  <span>1.000+ Đề thi</span>
                </div>
              </div>
            </b-col>
            <b-col cols="12" sm="4">
              <div class="statistic__item clearfix">
                <div class="statistic__item__icon">
                  <img src="@/assets/images/pages/home/map.svg" width="96" alt="25+ Quốc gia">
                </div>
                <div class="statistic__item__content">
                  <span>25+ Quốc gia</span>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>

    <div class="featured__exam">
      <b-container>
        <h3 class="featured__exam__title mb-4">Đề thi nổi bật</h3>
        <b-row>
          <b-col v-for="exam in examList" :key="exam.id" cols="12" sm="6" md="3">
            <ExamBox :exam="exam" />
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="featured__category">
      <b-container>
        <h3 class="featured__category__title mb-4">Chuyên mục đề thi HSK</h3>
        <b-row>
          <b-col v-for="(category, index) in examCategoryList" :key="category.id" md="4" sm="6" xs="12">
            <div :class="'category__item category__item--' + (index + 1)">
              <div class="category__img">
                <img width="100px" :src="cdnUrl + category.thumbnail" alt="">
              </div>
              <h4 class="category__name">
                <b-link :to="{ name: 'exam-category', params: { id: category.id, slug: category.slug } }" :title="category.name">{{ category.name }}</b-link>
              </h4>
              <div class="category__count">({{ category.count }} Đề thi)</div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="welcome">
      <b-container>
        <b-row align-v="center">
          <b-col cols="12" md="6">
            <div class="welcome__img text-center">
              <img src="@/assets/images/bg_welcome.png" alt="">
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="welcome__content">
              <h3 class="welcome__content__title">TẠI SAO NÊN CHỌN TRYHSK ONLINE ?</h3>
              <div role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="welcome__content__header" role="tab">
                    <h4 class="welcome__content__sub-title" v-b-toggle.accordion-1>
                      Kiểm soát thời gian, cấu trúc sát với cấu trúc thi thật
                    </h4>
                  </b-card-header>
                  <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>TRYHSK là một nền tảng thi thử HSK toàn diện, được thiết kế để mô phỏng trải nghiệm kỳ thi thực tế một cách chân thực nhất.<br/>Nền tảng cung cấp một kỳ thi thử HSK với khung thời gian sát với đề thi chính thức.<br/>Mỗi bài thi được thiết kế như một buổi luyện tập thực sự, giúp người dùng đánh giá khả năng của mình và cải thiện hiệu suất dưới điều kiện thi thật. Giúp cải thiện nhằm giúp người dùng xác định những điểm cần hoàn thiện và đạt được mục tiêu về trình độ ngôn ngữ của mình.</b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="welcome__content__header" role="tab">
                    <h4 class="welcome__content__sub-title" v-b-toggle.accordion-2>
                      Ma trận đề ngẫu nhiên không trùng lặp
                    </h4>
                  </b-card-header>
                  <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>TRYHSK có nền tảng công nghệ cao cho phép chọn đề ngẫu nhiên mà không hề trùng lặp, cùng ma trận đề độc quyền do chuyên gia xây dựng.</b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="welcome__content__header" role="tab">
                    <h4 class="welcome__content__sub-title" v-b-toggle.accordion-3>
                      Tư vấn riêng biệt, bổ sung kiến thức, cung cấp tài liệu
                    </h4>
                  </b-card-header>
                  <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>Mỗi học viên đều có trợ lý cá nhân tư vấn lộ trình học riêng biệt, phù hợp với điều kiện và trình độ của bản thân. Trong quá trình học, học viên được bổ sung kiến thức, cung cấp tài liệu để tiến bộ từng ngày.</b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="welcome__content__header" role="tab">
                    <h4 class="welcome__content__sub-title" v-b-toggle.accordion-4>
                      Đề thi cập nhật, sát đề thi thật
                    </h4>
                  </b-card-header>
                  <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>Với nhiều năm kinh nghiệm luyện thi HSK, TRYHSK Online xây dựng ngân hàng đề thi bám sát bảng từ vựng, ngữ pháp của Hán ban. Đề thi được biên soạn bởi đội ngũ giảng viên TRYHSK, cập nhật theo từng đợt thi.</b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="review">
      <b-container>
        <h3 class="review__title">Khách hàng nói gì về chúng tôi</h3>

        <div class="review__slide">
          <b-carousel ref="carousel" v-model="slide" :interval="4000">
            <b-carousel-slide v-for="(item, index) in sliders" :key="index" img-blank>
              <template v-slot:img></template>
              <div class="review__slide__item">
                <b-row align-v="center">
                  <b-col>
                    <img
                      class="slide__img"
                      :src="cdnUrl + item.image"
                      alt=""
                    />
                  </b-col>
                  <b-col cols="12" md="6">
                    <div class="slide__content">
                      <span class="slide__level">Điểm số: {{ item.point }} điểm</span>
                      <span class="slide__level">Cấp độ: {{ item.level }}</span>

                      <p class="mt-3">{{ item.content }}</p>

                      <h4 class="slide__customer">{{ item.name }}</h4>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-carousel-slide>
          </b-carousel>

          <div class="review__slide__control">
            <span @click="prevSlide">&larr;</span>
            <span>{{ slide + 1 }} / {{ sliders.length }}</span>
            <span @click="nextSlide">&rarr;</span>
          </div>
        </div>
      </b-container>
    </div>

    <div class="list__article">
      <b-container>
        <h3 class="list__article__title mb-4">Tin tức</h3>
        <b-row>
          <b-col v-for="article in articleList" :key="article.id" cols="12" md="3" sm="6">
            <div class="list__article__item">
              <div class="post__img">
                <img :src="cdnUrl + article.thumbnail" alt="" />
              </div>
              <div class="post__content">
                <h4 class="post__title">
                  <b-link
                    :to="{
                      name: 'news-detail',
                      params: { id: article.id, slug: article.slug }
                    }"
                    :title="article.title"
                    >{{ article.title }}</b-link
                  >
                </h4>
                <div class="post__time">
                  <span>{{ ('00'+parseUTCDate(article.published_at).date()).slice(-2) }}-{{ ('00'+parseUTCDate(article.published_at).month()).slice(-2) }}</span>
                  <span class="post__time__separator"></span>
                  <span>{{ parseUTCDate(article.published_at).year() }}</span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="magazine">
      <b-container>
        <h3 class="magazine__title">Báo chí nói gì về chúng tôi</h3>
        <b-row>
          <b-col cols="6" sm="3">
            <img class="magazine__img" src="@/assets/images/ic_vn.png" alt="" />
          </b-col>
          <b-col cols="6" sm="3">
            <img class="magazine__img" src="@/assets/images/ic_tt.png" alt="" />
          </b-col>
          <b-col cols="6" sm="3">
            <img
              class="magazine__img"
              src="@/assets/images/ic_vtc.png"
              alt=""
            />
          </b-col>
          <b-col cols="6" sm="3">
            <img
              class="magazine__img"
              src="@/assets/images/ic_vtv.png"
              alt=""
            />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="follower">
      <b-container>
        <b-row>
          <b-col cols="12" sm="4" class="separator">
            <h4>18.166</h4>
            <span class="text-uppercase">TÀI KHOẢN LUYỆN HSK</span>
          </b-col>
          <b-col cols="12" sm="4" class="separator">
            <h4>1.258</h4>
            <span class="text-uppercase">ĐỀ THI</span>
          </b-col>
          <b-col cols="12" sm="4">
            <h4>115.325</h4>
            <span class="text-uppercase">LƯỢT THI</span>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="newsletter">
      <b-container>
        <b-form>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="4">
              <span>Nhận thông báo miễn phí</span>
              <h5>Đăng ký nhận thông báo của chúng tôi</h5>
            </b-col>
            <b-col cols="6" md="6">
              <b-input
                id="inline-form-input-email"
                class="newsletter__input mb-2 mr-sm-2 mb-sm-0"
                placeholder="Nhập email của bạn"
              ></b-input>
            </b-col>
            <b-col cols="6" md="2">
              <b-button class="newsletter__btn">Gửi</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </div>
  </div>
</template>

<script>
// import JWT from "@/utils/jwt"
// import axios from 'axios';
import { APP_CONFIG } from "@/utils/constants";
import { mapActions, mapGetters } from "vuex";
import ExamBox from '@/components/widgets/ExamBox.vue';
import moment from "moment";

export default {
  name: "home",
  components: {
    ExamBox
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      slide: 0,
      sliders: [
        {
          name: "Bùi Thị Hải Như",
          level: "HSK 4",
          point: 266,
          image: "/uploads/images/reviews/01.jpg",
          content: "TRYHSK Online đã giúp em luyện thi HSK hiệu quả mà không phải đến trung tâm học. Nhờ những chỉ dẫn của thầy cô giáo khi chấm bài mà điểm số của em tăng theo từng ngày. Cảm ơn TRYHSK Online!"
        },
        {
          name: "Tống Thị Len",
          level: "HSK 5",
          point: 243,
          image: "/uploads/images/reviews/02.jpg",
          content: "Những học sinh ở xa như em không có điều kiện học tiếng Trung bài bản mà đa phần là tự học. TRYHSK Online đã giúp em vượt qua trở ngại về địa lý, giúp em đạt số điểm khá cao trong kì thi HSK 5. Nhờ đó mà em đã tìm được một công việc tốt hơn, với mức lương gấp rưỡi trước kia."
        },
        {
          name: "Trần Thị Ngọc Mai",
          level: "HSK 6",
          point: 244,
          image: "/uploads/images/reviews/03.jpg",
          content: "Khi luyện thi HSK 6 với TRYHSK Online, em đã rất bất ngờ, không nghĩ chỉ thi online thôi cũng có thể nhận được những lời phê cụ thể, chi tiết đến thế từ các thầy cô giáo của TRYHSK. Và em càng bất ngờ hơn khi đi thi thấy nội dung đề thật rất sát với nội dung mình đã luyện trên website."
        },
        {
          name: "Nguyễn Linh Chi",
          level: "HSK 3",
          point: 280,
          image: "/uploads/images/reviews/04.jpg",
          content: "Từ khi biết đến TRYHSK Online, em chăm chỉ học tiếng Trung hơn. Em làm đề HSK mọi lúc, mọi nơi, từ ở trường, ở nhà cho đến quán café. Vì chỉ cần mang theo chiếc điện thoại và tai nghe thôi là cũng có thể tranh thủ học rồi. "
        },
        {
          name: "Đào Thị Hảo",
          level: "HSK 4",
          point:  278,
          image: "/uploads/images/reviews/02.jpg",
          content: "Em đã không nghĩ mình có thể kịp nộp hồ sơ du học Trung Quốc trong năm nay. Còn 2 tháng là tới hạn nộp hồ sơ, mà trình độ của em còn chưa đạt HSK 3. Sau đó em được cô giáo giới thiệu website này. Kiên trì mỗi tuần làm 3 đề HSK, cuối cùng em đã đạt HSK 4, thực hiện ước mơ du học Thượng Hải! Cảm ơn TRYHSK Online!"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      setings: "home/setings",
      examList: "home/examList",
      examCategoryList: "home/examCategoryList",
      articleList: "home/articleList"
    }),
  },
  methods: {
    ...mapActions("home", [
      "getSetting",
      "getExamList",
      "getExamCategoryList",
      "getArticleList"
    ]),
    parseUTCDate(ts) {
      return moment.unix(ts)
    },
    prevSlide() {
      if (this.slide >= 0) {
        this.slide--;
      }
    },
    nextSlide() {
      if (this.slide < this.sliders.length) {
        this.slide++;
      }
    }
  },
  async mounted() {
    // const token = JWT.getAccessToken();
    
    // if (!token) return;
    // const response = await axios.get('https://api.tryhsk.com/api/surveys', {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // });
    // if (response.data.success) {
    //   this.$router.push({ name: "khao-sat" });
    // }
  },
  beforeMount() {
    this.getSetting();
    this.getExamList();
    this.getExamCategoryList();
    this.getArticleList();
  },
  metaInfo() {
    return {
      title: this.setings.seo_title || "TRYHSK Online",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.setings.seo_description || "Luyện thi HSK Online, thi chứng chỉ tiếng Trung trực tuyến chính xác nhất."
        },
        {
          vmid: "keywords",
          name: "keywords",
          content: this.setings.seo_keyword
        },
        { vmid: "robots", name: "robots", content: "index, follow" },
        // OPG
        {
          property: "og:title",
          content: this.setings.seo_title || "TRYHSK Online"
        },
        { property: "og:site_name", content: "TRYHSK Online" },
        // The list of types is available here: http://ogp.me/#types
        { property: "og:type", content: "article" },
        { property: "article:author", content: "https://tryhsk.com/" },
        { property: "og:url", content: `${process.env.BASE_URL}` },
        { property: "og:description", content: this.setings.seo_description || "Luyện thi HSK Online, thi chứng chỉ tiếng Trung trực tuyến chính xác nhất." },
        { property: "og:image", content: "https://cdn.tryhsk.com/uploads/articles/2020/03/18/5e71d24681a3d3339571.jpg" }
      ],
      link: [{ rel: "canonical", href: `${process.env.BASE_URL}` }]
    };
  }
};
</script>
